export const { REACT_APP_API_BASE: API_BASE } = process.env;
export const { REACT_APP_WORDPRESS_BASE: WORDPRESS_BASE } = process.env;

export const API_LOGIN = "/v2/users/login";

export const API_LOGOUT = "/v2/common/commonLogOut";

export const API_UPDATE_FCM_TOKEN = "/v2/common/updateFcmToken";

export const API_DELETE_ACCOUNT = "/v2/users/delete/";

export const API_META = "/v2/auth/metaData";

export const API_REGISTRATION = "/v2/users/create";

export const API_VERIFY_OTP = "/v2/users/verify-otp";

export const API_RESEND_OTP = "/v2/users/resend-otp";

export const API_SEND_EMAIL_CODE = "/v2/users/send-email-code";

export const API_VERIFY_EMAIL_CODE = "/v2/users/verify-email-code";

export const API_SEND_MY_EMAIL_CODE = "/v2/users/profile/send-email-code";

export const API_VERIFY_MY_EMAIL_CODE = "/v2/users/profile/verify-email-code";

export const API_VERIFY_EMAIL = "/v2/users/sentMailToUser";

export const API_FORGOT_PASS = "/v2/users/forgotPassword";

export const API_CHANGE_PASS = "/v2/users/changePassword";

export const API_RESET_PASS = "/v2/users/resetPassword";

export const API_USER_DETAILS = "/v2/users/getUserDetails";

export const API_UPDATE_USER_DETAILS = "/v2/users/updateUserDetails";

export const API_CHARITY_LIST = "/v2/charity/charityFilter";

export const API_CHARITY_DETAILS = "/v2/charity/charityDetails";

export const API_CAUSE_LIST = "/v2/cause/causesList";

export const API_CAUSE_DETAILS = "/v2/cause/causesDetails";

export const API_HOMEPAGE_DETAILS = "/v2/homepage/dynamicData";

export const API_ABOUTPAGE_DETAILS = "/v2/aboutUs/aboutUsList";

export const API_IMAGE_UPLOAD = "/v2/local-image/uploadImage";
export const API_IMAGE_DELETE = "/v2/local-image/removeImage";

export const API_VIDEO_UPLOAD = "/v2/local-image/uploadVideo";
export const API_VIDEO_DELETE = "/v2/local-image/removeVideo";

export const API_REFRESH_TOKEN = "/v2/common/refreshToken";

export const API_BADGE_LIST = "/v2/users/badgesList/";
export const API_DONATION_GOAL = "/v2/users/addUserGoal";
export const API_UPLOAD_USER_PROFILE = "/v2/users/uploadUserImage";

// charity related api
export const API_CHARITY_COMMUNITY_LIST = "/v2/charity/charityCommunityDetails";

//cause related api
export const API_CAUSE_COMMUNITY_LIST = "/v2/cause/causeCommunityDetails";

// charity registration related api
export const API_CATEGORY = "/v2/admin/charity-category/getAll";
export const API_CAUSE = "/v2/admin/cause/getAll";
export const API_CHARITY_REGISTRATION = "/v2/admin/charity/create";

export const API_COUNTRY = "/v2/common/getAllCountry";
export const API_STATE = "/v2/common/getAllState";
export const API_CITY = "/v2/common/getAllCities";

// communtiy api

export const API_ALL_COMMUNITY = "/v2/community/getAllCommunityList";
export const API_NOT_ASSO_COMMUNITY =
  "/v2/community/getAllCommunityListNotAssociated";
export const API_COMMUNITY_DETAILS = "/v2/community/getCommunityDetail/";
export const API_JOIN_COMMUNITY = "/v2/joinCommunity/add";
export const API_LEAVE_COMMUNITY = "/v2/joinCommunity/";
export const API_CREATE_COMMUNITY_RATING = "/v2/community-rating/create";
export const API_UPDATE_COMMUNITY_RATING = "/v2/community-rating/update/";
export const API_GET_COMMUNITY_MEMBERS = "/v2/community/memberList/";

// favour charity and list api

export const API_ADD_CHARITY_TO_FAV = "/v2/favoritelist/addCharity";
export const API_ADD_CAUSE_TO_FAV = "/v2/favoritelist/addCause";
export const API_REMOVE_CHARITY_OR_CAUSE_TO_FAV = "/v2/favoritelist/remove";
export const API_FAV_LIST = "/v2/favoritelist/list";

// event api

export const API_EVENT_LIST = "/v2/event/eventFilterByCommunity";
export const API_EVENT_DETAILS = "/v2/event/eventDetails";
export const API_JOIN_EVENT = "/v2/event/join";
export const API_UPDATE_EVENT = "/v2/event/updateStatus";
export const API_EVENT_LIST_OF_CAUSE = "/v2/event/causeEventList/";
export const API_EVENT_LIST_OF_CHARITY = "/v2/event/eventList/";
export const API_MY_EVENT_LIST = "/v2/event/userFavEventList";
export const API_ALL_UPCOMING_EVENT_LIST = "/v2/event/userAllUpcomingEventList";

// post module
export const API_COMMUNITY_POST_LIST = "/v2/posts/getAllCommunityPostList/";
export const API_CREATE_POST = "/v2/posts";
export const API_LIKE_UNLIKE_POST = "/v2/posts/likeUnlikePost/";
export const API_HIDE_POST = "/v2/posts/hidePost";
export const API_DELETE_POST = "/v2/posts/";
export const API_REPORT_POST = "/v2/posts/reportPost/";
export const API_POST_COMMENT = "/v2/posts/postComment";
export const API_RENDER_COMMENTS = "/v2/posts/getPostCommnetList/";
export const API_LIKE_UNLIKE_COMMENTS = "/v2/posts/likeUnlikeComment/";
export const API_SHARE_POST = "/v2/posts/sharePost/";
export const API_USER_PROFILE_DETAILS = "/v2/posts/userProfileFeedData/";
export const API_USER_POST_LIST = "/v2/posts/userFriendPostList/";
export const API_JOIN_COMMUNITY_POST = "/v2/posts/communityUserPost";
export const API_COMMENT_REPLY = "/v2/posts/postCommentRply";

// contect us
export const API_CONTACT_US = "/v2/ContactUs/create";

// friend post
export const API_POST_LIST = "/v2/posts/getAllDonorFriendsPostList/";

// friend module
export const API_SEND_FRIEND_REQUEST = "/v2/web-friend/sendFriendRequest";
export const API_PENDING_FRIEND_REQUEST = "/v2/web-friend/pendingFriendRequest";
export const API_ACCEPT_REJECT_REQUEST = "/v2/web-friend/acceptedAndRejected";
export const API_FRIEND_LIST = "/v2/web-friend/approvedFriendRequest";
export const API_GET_ALL_USER_LIST = "/v2/web-friend/findDonor";
export const API_MUTUAL_FRIEND_LIST = "/v2/web-friend/mutualFriendList";
export const API_UNFRIEND_FRIEND = "/v2/web-friend/unFriend";

//basket module
export const API_ADD_TO_BASKET = "/v2/basket/addToBasket";
export const API_BASKET_DETAILS = "/v2/basket/getBasketDetails";
export const API_REMOVE_ITEM_FROM_BASKET = "/v2/basket/removeBasket";
export const API_BASKET_COUNT = "/v2/basket/basketCount/";

//payment module
export const API_PAYMENT_WITH_UNSAVED_CARD =
  "/v2/payment/makePaymentWithUnSavedCard";
export const API_PAYMENT_WITH_SAVED_CARD =
  "/v2/payment/makePaymentWithSavedCard";
export const API_LIST_OF_ALL_CARD = "/v2/payment/listAllCards";
export const API_ADD_CARD = "/v2/payment/addToCard";
export const API_DELETE_CARD = "/v2/payment/deleteSavedCard";
export const API_TRANSECTION_LIST = "/v2/payment/transactionList";
export const API_CANCEL_SUBSCRIPTION = "/v2/payment/cancleSubscription";
export const API_TRANSECTION_RECIEPT = "/v2/payment/generateTransactionReciept";
export const API_ALL_TRANSACTION_PDF = "/v2/payment/allTransactionPdf";
export const API_UPDATE_SUBSCRIPTION = "/v2/payment/subscriptionUpdate/";
export const API_SUBSCRIPTION_DETAILS = "/v2/payment/subscriptionDetails/";
export const API_UPDATE_SUBSCRIPTION_ITEMS =
  "/v2/payment/getUpdateSubPercenatge/";
export const API_UPDATE_SUBSCRIPTION_PERCENTAGE =
  "/v2/payment/subPercentageUpdate";

// cms
export const API_CMS_DETIALS = "/v2/web-cms-pages/ViewCms/";

// faq
export const API_FAQ_CATEGORY_LIST =
  "/v2/admin/admin-faq-category/faqCategoryList";
export const API_FAQ_LIST = "/v2/admin/admin-faq/faqList";

// chat
export const API_CHAT_CREATE_ROOM = "/v2/chat/createRoom";
export const API_CHAT_NOTIFICATION_COUNT = "/v2/chat/getChatCount";

//Strategic-Employee
export const API_STRATEGIC_PARTNER_REGISTRATION =
  "/v2/strategic-partner/create";
export const API_STRATEGIC_PARTNER_LIST =
  "/v2/strategic-partner/strategicPartnerList";
export const API_CREATE_EMPLOYEE = "/v2/admin/employee/createEmployee";
export const API_STRATEGIC_DETAIL = "/v2/strategic-partner/get/";
export const API_STRATEGIC_MUTUAL_LIST =
  "/v2/strategic-partner/mutualFriendList";
export const API_STRATEGIC_MEMBER_LIST =
  "/v2/strategic-partner/strategicPartnerList";
export const API_EMPLOYEE_POST_LIST = "/v2/posts/employeePost/";
export const API_STRATEGIC_MUTUAL_FRIEND =
  "/v2/strategic-partner/mutualFriendList";
export const API_STRATEGIC_EVENT = "/v2/event/listStrategicPartner/";

//Searh API
export const API_GLOBAL_SEARCH = "/v2/homepage/commonSearch";

// giving partner
export const API_GIVING_PARTNER_DETAILS = "/v2/givingpartnerpage/details";

// Notifiction
export const API_NTIFICTION_DELETE = "/v2/notification/";
export const API_NOTIFICTION_LIST = "/v2/notification/list";
export const API_FETCHNOTIFICATION_LIST =
  "/v2/notification/fetchNotificationDetails";

  
//Chat
export const API_CLEARE_CHAT_HISTORY = "/v2/chat/clearChatHistory/";
